import React, { useState, useEffect } from 'react';

import { useMessages } from '../hooks/useMessages';
import ListMessages from '../components/widget/ListMessages';
import Search from '../components/html/Search';
import * as Util from '../data/General';
import { is } from 'date-fns/locale';


function Messages(props) {
  const [selected, setSelected] = useState(null);
  const [idElement, setIdElement] = useState(null);
  const [selectedData, setSelectedData] = useState(null);
  const [ticketLoading, setTicketLoading] = useState(false);
  
  const {data, isLoad, searchText, incrementPage, clear, setNewFilter, filter, setInbox, isInbox, refreshData} = useMessages({ method:"GET"})

  const getConversationId = (item) => {
    if(!item){
      return null;
    }
    return item.conversationId ? item.conversationId : item.id;
  }

  const isTicket = (item) => {
    return !!(item && item.humanRequest);
  }
  
  useEffect(() => {
    if(data && data.length > 0){
      const selectedExists = selected !== null && data.some((item) => getConversationId(item) === selected);
      const nextSelected = (selected === null || !selectedExists) ? data[0] : data.find((item) => getConversationId(item) === selected);

      if(nextSelected){
        setSelectedElement(nextSelected);
        if((selected === null || !selectedExists) && nextSelected.inbox && nextSelected.inbox > 0){
          markasread(getConversationId(nextSelected));
        }
      }
    }else if(data && data.length === 0){
      setSelected(null);
      setSelectedData(null);
      setIdElement(null);
    }
    return () => {
      clear();
    }
  },[data]);

  const setSelectedElement = (item) => {
    setSelected(getConversationId(item)); 
    setSelectedData(item); 
    setIdElement(item.conversationId ? item.id : null)
  }

  const getDate = (varDate) =>{
    if(varDate && typeof varDate === 'string'){
      let arr = varDate.split("T");
      let day = arr[1].split("-");
      let min = day[0].split(":");
      return arr[0];
      
    }
    return "";
  }
  
  const firstLetter = (str) => {
    if (str === null || str.length === 0) {
      return "N"; // Handle empty strings
    }
    return str.charAt(0).toUpperCase();
  }

  const addCount = () =>{
    if(!isLoad){
      incrementPage();
    }
  }

  const searchFinish = (text) =>{
    searchText(text);
  }

  const setClear = () => {
    searchText("");
  }

  useEffect(() => {
    if(data && data.length > 0 && selected !== null && selectedData.inbox && selectedData.inbox > 0){
      markasread(selected);
    }
  },[selected]);

  const markasread = (str) => {
    console.log("markasread",str);
    setInbox(str);
    Util.callServer(dataOk, dataOk, `inboxs/conversations/${str}/markasread`,{}, "POST");
  }

  const dataOk = (data) => {
  }

  const updateHumanRequest = (humanRequest) => {
    if(!selected || !selectedData || ticketLoading){
      return;
    }
    setTicketLoading(true);
    Util.callServer(
      () => {
        setSelectedData((prev) => prev ? {...prev, humanRequest} : prev);
        refreshData();
        setTicketLoading(false);
      },
      () => {
        setTicketLoading(false);
      },
      `inboxs/conversations/${selected}`,
      { humanRequest },
      "PUT"
    );
  }

 
  return (
    <div className='messages'>
      <div className='messages-list'>
        <Search searchFinish={searchFinish} clear={setClear}/>
        <div className='content-filter-messages'>
            <div className={filter === "all" ? 'active' : ''} onClick={() => setNewFilter("all")}>
              Todos
            </div>
            <div className={filter === "unread" ? 'active' : ''} onClick={() => setNewFilter("unread")}>
              No leídos
            </div>
            <div className={filter === "tickets" ? 'active' : ''} onClick={() => setNewFilter("tickets")}>
              Tickets
            </div>
            <div className={(filter !== "unread" && filter !== "all" && filter !== "tickets" && filter !== "") ? 'active' : ''} >
              <select value={filter} className="form-control-select" onChange={(e) => setNewFilter(e.target.value)}>
                <option value="all">Categoría</option>
                <option value="REVIEW">Review</option>
                <option value="MARKETING">Marketing</option>
                <option value="NOTIFICATION">Notificaciones</option>  
                <option value="CHAT">Chats</option>  
                <option value="CHATBOT">Lia (IA)</option>  
              </select>
            </div>
        </div>
        <ul>
          {isLoad ? <div className="lds-ellipsis"><div></div><div></div><div></div><div></div></div> : null}
          {data && data.length > 0 && data.map((item) => (
            <li key={item.id} className={selected === getConversationId(item) ? "selected" : ""} onClick={() => {setSelectedElement(item)}}>
              <div className='img'>{firstLetter(item.contact.firstName)}{firstLetter(item.contact.lastName)}</div>
              <div className='content'>
                <div className='title-row'>
                  <span>{item.contact.firstName} {item.contact.lastName}</span>
                  {isTicket(item) ? <small className='ticket-badge'>Ticket</small> : null}
                </div>
                <span>{item.mediaContentType === "image/jpeg" ? "Imagen" : item.mediaContentType === "audio/ogg" ? "Audio" : item.body}</span>
              </div>
              <div className='date'>{getDate(item.updatedAt)}</div>
              {isInbox(item) ? <div className='inbox'>{item.inbox}</div> : null}
            </li>
          ))}
        </ul>
        {data && data.length > 25 ? <div className={`more ${isLoad ? "opacity-60" : ""}`} onClick={() => {addCount()}}>Mas</div> : null}
      </div>
      {selected ? (
        <div className='messages-content'>
          <div className='messages-header'>
            <div className='messages-list'>
              <ul>
                <li>
                  <div className='img'>{firstLetter(selectedData.contact.firstName)}{firstLetter(selectedData.contact.lastName)}</div>
                  <div className='content'>
                    <div className='title-row'>
                      <span>{selectedData.contact.firstName} {selectedData.contact.lastName}</span>
                      {isTicket(selectedData) ? <small className='ticket-badge open'>Ticket abierto</small> : <small className='ticket-badge'>Lia activa</small>}
                    </div>
                    <span><a href={`https://wa.me/${selectedData.contact.phone}`} target="_blank">{selectedData.contact.phone}</a></span>
                  </div>
                  <div className='messages-header-actions'>
                    <button
                      className={`ticket-action ${isTicket(selectedData) ? 'resolve' : 'open'}`}
                      disabled={ticketLoading}
                      onClick={() => updateHumanRequest(!isTicket(selectedData))}
                    >
                      {ticketLoading ? "Guardando..." : isTicket(selectedData) ? "Resolver ticket" : "Marcar como ticket"}
                    </button>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          {<ListMessages idMessage={selected} idElement={idElement}/>}
        </div>
      ) : <div></div>}
    </div>
);
}

export default Messages;
